import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
  OrgIdNameDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { UnassignedOrgsTable } from "@src/features/admin/pages/agencies/components/Tables/UnassignedOrgsTable/UnassignedOrgsTable";

interface UnassignedOrgsContentProps {
  item: AgencySubscriptionItemDto;
  subscription: AgencySubscriptionDto;
  unassignedOrgs: OrgIdNameDto[];
  agency: FullAgencyDto;
}

export const UnassignedOrgsContent = ({
  item,
  subscription,
  agency,
  unassignedOrgs,
}: UnassignedOrgsContentProps) => {
  if (unassignedOrgs.length) {
    return (
      <Grid container item direction={"column"}>
        <Grid item>
          <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
            Unassigned Orgs:
          </IgTypography>
        </Grid>
        <UnassignedOrgsTable
          item={item}
          agency={agency}
          unassignedOrgs={unassignedOrgs}
          subscription={subscription}
        />
      </Grid>
    );
  }
  return null;
};
